// src/components/realisations/ProjectProcessSection.js
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import './ProjectProcessSection.css'; // Son propre CSS

function ProjectProcessSection() {
  const projectSteps = [
    { 
      id: 1, 
      number: "01", 
      title: "Brief & Cadrage", 
      description: "Analyse approfondie de vos objectifs, de votre cible et de vos contraintes pour définir clairement le périmètre du projet.",
      icon: "🎯" // Target
    },
    { 
      id: 2, 
      number: "02", 
      title: "Conception Créative", 
      description: "Élaboration de l'identité visuelle, des maquettes et des prototypes pour donner vie à une première vision de votre projet.",
      icon: "💡" // Idea
    },
    { 
      id: 3, 
      number: "03", 
      title: "Développement & Intégration", 
      description: "Transformation des designs en un site ou une application fonctionnelle, en utilisant les technologies les plus adaptées.",
      icon: "💻" // Laptop
    },
    { 
      id: 4, 
      number: "04", 
      title: "Tests & Recette", 
      description: "Vérification minutieuse de chaque fonctionnalité, de la performance et de la compatibilité sur tous les supports.",
      icon: "🧪" // Test tube
    },
    { 
      id: 5, 
      number: "05", 
      title: "Lancement & Suivi", 
      description: "Mise en ligne de votre projet, accompagnée d'une analyse des premiers résultats et d'un support pour les ajustements.",
      icon: "🎉" // Party popper
    }
  ];

  return (
    <section className="project-process-section">
      <h2 className="section-title">Notre Processus de Création</h2>
      
      <Swiper
        modules={[Navigation, Pagination, A11y]}
        spaceBetween={30}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        grabCursor={true}
        breakpoints={{
          640: { slidesPerView: 2, spaceBetween: 20 },
          900: { slidesPerView: 3, spaceBetween: 30 }, // Ajusté pour potentiellement 3 slides plus tôt
        }}
        className="project-process-swiper"
      >
        {projectSteps.map(step => (
          <SwiperSlide key={step.id}>
            <div className={`creation-step-card ${step.icon ? 'has-icon' : ''}`}>
              <div className="creation-step-number">{step.number}</div>
              {step.icon && <div className="creation-step-icon" role="img" aria-label={step.title}>{step.icon}</div>}
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default ProjectProcessSection;